// PATH: src/api/dashboard.ts — vue d'ensemble de la direction (page d'accueil).
// Réservé à la direction côté backend (403 attendu sinon) : la page dégrade
// gracieusement plutôt que de bloquer.
import { useMemo } from "react";
import { useApiClient } from "./apiClients";

const BASE = "/api/v1/school";

export interface AttendanceToday {
  date: string;
  absences: number;
  lates: number;
  students_flagged: number;
  unjustified_absences: number;
}

export interface UpcomingExam {
  title: string;
  subject_name: string;
  class_label: string;
  kind: string; // CONTROLE_CONTINU | EXAMEN
  date: string;
}

export interface DashboardSummary {
  active_students: number;
  attendance_today: AttendanceToday;
  upcoming_exams: UpcomingExam[];
}

export const useDashboardApi = () => {
  const http = useApiClient("tilmischool");
  return useMemo(
    () => ({
      get: () => http.get<DashboardSummary>(`${BASE}/dashboard`).then((r) => r.data),
    }),
    [http]
  );
};
